import {
  SET_CALENDAR_EVENTS,
  SET_CALENDAR_FLOWS,
  SET_SAVE_SCHEDULE_SUCCESS,
  SET_SAVE_SCHEDULE_SUCCESS_RESET,
  SET_SAVE_SCHEDULE_FAILED,
  SET_SAVE_SCHEDULE_FAILED_RESET,
  SET_SHARED_SCHEDULES,
} from "redux/constants/flowDesigner";

const initialState = {
  calendarEvents: [],
  flows: [],
  saveScheduleSuccess: false,
  saveScheduleFailed: false,
  sharedSchedules: [],
};

const calendar = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_CALENDAR_EVENTS:
      return {
        ...state,
        calendarEvents: payload,
      };
    case SET_CALENDAR_FLOWS:
      return {
        ...state,
        flows: payload,
      };
    case SET_SAVE_SCHEDULE_SUCCESS:
      return {
        ...state,
        saveScheduleSuccess: true,
      };
    case SET_SAVE_SCHEDULE_SUCCESS_RESET:
      return {
        ...state,
        saveScheduleSuccess: false,
      };
    case SET_SAVE_SCHEDULE_FAILED:
      return {
        ...state,
        saveScheduleFailed: true,
      };
    case SET_SAVE_SCHEDULE_FAILED_RESET:
      return {
        ...state,
        saveScheduleFailed: false,
      };
    case SET_SHARED_SCHEDULES:
      return {
        ...state,
        sharedSchedules: payload,
      };
  }

  return state;
};

export default calendar;
